import _response from "./Response/Response";
import _attribute from "./Attribute/Attribute";
import _files from "./Files/Files";
import _system from "./System/System";
import _textEditor from "./TextEditor/TextEditor";

const Response = _response;
const Attribute = _attribute;
const Files = _files;
const System = _system;
const TextEditor = _textEditor;

export { Response, Attribute, Files, System, TextEditor };
